<template>
  <div>
    <NuxtLink :to="`/orgs/${org._id}`" class="">Back to {{org.name}}</NuxtLink>

    <h2
      class="text-6xl font-extrabold leading-none tracking-tight text-gray-900 dark:text-white"
    >
      {{ client.name }}
    </h2>
    
    <UpdateClient :client="client" :org="org" />

    <Section>
      <div class="text-2xl font-bold mb-5">
        Searches
        <CreateSearch :client="client" />
      </div>
      <SearchesTable :client="client" />
    </Section>

  </div>
</template>

<script setup>
import _ from "lodash";
import { computed } from "vue";
import UpdateClient from "~/features/clients/UpdateClient.vue";
import { useOrgStore, useClientStore } from "~/store";
import CreateSearch from "~/features/searches/CreateSearch.vue";
import SearchesTable from "~/features/searches/SearchesTable.vue";

const clientStore = useClientStore();
const orgStore = useOrgStore();

const route = useRoute();
const { clientId } = route.params;
const client = computed(() => clientStore.getClient(clientId));
const org = computed(() => orgStore.getOrg(client.value.orgId));

</script>

<style scoped>
/* CSS specific to this page */
</style>
